import { render, staticRenderFns } from "./extra-html.vue?vue&type=template&id=703d4517&lang=pug&"
import script from "./extra-html.vue?vue&type=script&lang=js&"
export * from "./extra-html.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports